import React from 'react';
import { FileSignature, RotateCcw } from 'lucide-react';

const HoursDigitalSignatures = ({ 
  signatures, 
  currentCrewMember, 
  onSignatureClick,
  onClearSignature 
}) => {
  return (
    <div className="mt-6 border-t border-gray-200 pt-4 no-print">
      <div className="space-y-4">
        <div>
          <h4 className="text-sm font-medium text-gray-900">Digital Signatures</h4>
          <p className="text-xs text-gray-500 mt-1">
            Click below to add digital signatures to confirm these Hours of Rest records
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Crew Member Signature */}
          <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <h5 className="text-sm font-medium text-gray-900">Crew Member Signature</h5>
                <p className="text-xs text-gray-500">{currentCrewMember?.full_name || currentCrewMember?.name}</p>
              </div>
              {!signatures.crew ? (
                <button
                  onClick={() => onSignatureClick('crew')}
                  className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50"
                >
                  <FileSignature className="h-3.5 w-3.5 mr-1.5" />
                  Sign
                </button>
              ) : (
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Signed
                  </span>
                  <button
                    onClick={() => onClearSignature('crew')}
                    className="inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium rounded text-gray-600 bg-white hover:bg-gray-50"
                    title="Clear and re-sign"
                  >
                    <RotateCcw className="h-3 w-3" />
                  </button>
                </div>
              )}
            </div>
            {signatures.crew && (
              <div className="mt-3">
                <img 
                  src={signatures.crew.data} 
                  alt="Crew signature" 
                  className="h-12 border border-gray-200 rounded"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Signed on {new Date(signatures.crew.timestamp).toLocaleString()}
                </p>
              </div>
            )}
          </div>

          {/* Authorized Person's Signature */}
          <div className="border border-gray-200 rounded-lg p-4">
            <div className="flex items-start justify-between">
              <div>
                <h5 className="text-sm font-medium text-gray-900">Authorized Person Signature</h5>
                <p className="text-xs text-gray-500">{signatures.master?.role || 'Supervisor / Manager'}</p>
              </div>
              {!signatures.master ? (
                <button
                  onClick={() => onSignatureClick('master')}
                  className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50"
                >
                  <FileSignature className="h-3.5 w-3.5 mr-1.5" />
                  Sign
                </button>
              ) : (
                <div className="flex items-center gap-2">
                  <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                    Signed
                  </span>
                  <button
                    onClick={() => onClearSignature('master')}
                    className="inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium rounded text-gray-600 bg-white hover:bg-gray-50"
                    title="Clear and re-sign"
                  >
                    <RotateCcw className="h-3 w-3" />
                  </button>
                </div>
              )}
            </div>
            {signatures.master && (
              <div className="mt-3">
                <img 
                  src={signatures.master.data} 
                  alt="Master signature" 
                  className="h-12 border border-gray-200 rounded"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Signed by {typeof signatures.master.signedBy === 'object' ? signatures.master.signedBy?.name || 'Unknown' : signatures.master.signedBy || 'Unknown'} on {new Date(signatures.master.timestamp).toLocaleString()}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HoursDigitalSignatures;